import {ShiftsList} from "./ShiftsList";
import {ShiftsEdit} from "./ShiftsEdit";
import {ShiftsCreate} from "./ShiftsCreate";

export default {
    list: ShiftsList,
    create: ShiftsCreate,
    edit: ShiftsEdit
};
